/* eslint-disable react/no-danger */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Button } from 'src/@vymo/ui/atoms';
import { TabLayout } from 'src/@vymo/ui/blocks';
import { Widget } from 'src/@vymo/ui/molecules';
import { Keys, locale } from 'src/i18n';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import IndividualRankingCard from '../../components/myRankings';
import {
  getIndividualRankings,
  getLeaderboards,
  getRankings,
  getRankingsMeta,
  getRankingsTableInfo,
} from '../../selector';
import { fetchDashboardRankings } from '../../thunk';
import { getLeaderboardPayload } from './queries';
import RankingChart from './rankingChart';
import RankingList from './rankingList';
import styles from '../../index.module.scss';

function LeaderboardWidget() {
  const dispatch = useAppDispatch();
  const user = getCurrentUser();
  const leaderboards = useAppSelector(getLeaderboards);
  const rankings = useAppSelector(getRankings);
  const rankingsTableInfo = useAppSelector(getRankingsTableInfo);
  const rankingsMeta = useAppSelector(getRankingsMeta);
  const individualRanking = useAppSelector(getIndividualRankings);
  const [activeLeaderboard, setActiveLeaderboard] = useState<string>('');
  const [rankingView] = useState<string>('chart');

  useEffect(() => {
    setActiveLeaderboard(leaderboards?.[0]?.code || '');
  }, [leaderboards]);

  useEffect(() => {
    if (activeLeaderboard) {
      dispatch(
        fetchDashboardRankings({
          payload: getLeaderboardPayload(
            { limit: 3, skip: 0 },
            user.code,
            activeLeaderboard,
          ),
        }),
      );
    }
  }, [activeLeaderboard, dispatch, user.code]);

  return (
    <Widget
      title={locale(Keys.LEADERBOARD)}
      content={
        <div className={styles.leaderboard}>
          {Boolean(leaderboards?.length) && (
            <TabLayout
              items={leaderboards?.map((item) => ({
                label: item.name || '',
                key: item.code || '',
              }))}
              defaultKey={activeLeaderboard}
              onChange={setActiveLeaderboard}
            />
          )}
          {!_.isEmpty(individualRanking) && (
            <IndividualRankingCard individualRanking={individualRanking} />
          )}
          {!_.isEmpty(rankings) &&
            (rankingView === 'list' ? (
              <RankingList
                title={rankingsTableInfo.title}
                rankings={[...(rankings || [])]
                  .sort((a, b) => b.points - a.points)
                  .slice(0, 3)}
              />
            ) : (
              <RankingChart
                rankings={[...(rankings || [])]
                  .sort((a, b) => b.points - a.points)
                  .slice(0, 3)}
              />
            ))}
        </div>
      }
      description={
        <span dangerouslySetInnerHTML={{ __html: rankingsMeta?.lastUpdated }} />
      }
      actions={
        <Button
          type="outlined"
          onClick={() => {
            window.location.hash = '/performance/leaderboard';
          }}
        >
          {locale(Keys.VIEW_ALL)}
        </Button>
      }
      classNames={styles.leaderboard__widget}
    />
  );
}

export default LeaderboardWidget;
